import React, { useEffect, useReducer } from 'react';
import { Button } from '@cityelectricalfactors/ui-components';

import TabTextbox from 'components/quick_orders/tab_textbox';
import QuickOrdersError from 'components/quick_orders/manual_entry/quick_orders_error';

import {
  copyPasteReducer,
  initialState,
  copyPasteActions,
} from './copy_paste_reducer';

const specialCharRegex = /[`!@#$%^&*()={};':"|,<>?~]/;

const CopyPasteForm = ({ copyPasteTextArea, setCopyPasteTextarea }) => {
  const [state, dispatch] = useReducer(copyPasteReducer, initialState);
  const { errorLines, errorMessages, copyPasteData } = state;

  const hasErrorLines = ({ specialChar, newLine, format }) =>
    specialChar.length || newLine.length || format.length;

  const onChange = event => setCopyPasteTextarea(event.target.value);

  const handleSubmit = () => {
    const textLines = copyPasteTextArea.split('\n');
    const newErrorLines = {
      specialChar: [],
      newLine: [],
      format: [],
    };

    const data = textLines.map((line, index) => {
      const linesSplitByComma = line.split(/[,]+/);
      const stockCode = linesSplitByComma[0];
      const quantity = linesSplitByComma[1];
      const lineNumber = index + 1;

      // checking for special characters
      if (specialCharRegex.test(stockCode) || specialCharRegex.test(quantity)) {
        newErrorLines.specialChar.push(lineNumber);
        return null;
      }

      // check for max line length OR if there is multiple entries on the same line
      if (
        line.length >= 35 ||
        linesSplitByComma[2] ||
        (quantity && quantity.trim().split(' ').length > 1)
      ) {
        newErrorLines.newLine.push(lineNumber);
        return null;
      }

      if (!quantity) {
        newErrorLines.format.push(lineNumber);
        return null;
      }

      return {
        stockCode,
        quantity: quantity.trim(),
      };
    });

    if (hasErrorLines(newErrorLines)) {
      dispatch({
        type: copyPasteActions.SET_ERROR_LINES,
        payload: newErrorLines,
      });
    } else {
      dispatch({ type: copyPasteActions.SET_COPY_PASTE_DATA, payload: data });
    }
  };

  useEffect(() => {
    if (copyPasteData.length) {
      // TODO: send data to API and populate the manual entry tab
    }
  }, [copyPasteData]);

  useEffect(() => {
    if (!copyPasteTextArea) {
      dispatch({ type: copyPasteActions.RESET_ERRORS });
    }
  }, [copyPasteTextArea]);

  return (
    <div className="copy-paste__form fl fl-col ai-fe">
      <TabTextbox showIcon>
        <>
          Copy and paste multiple products from a list using stock or part
          codes. Add quantities separated by a comma e.g.{' '}
          <span className="fw-500">product,qty</span>. Multiple products can be
          pasted at once as long as each item is on a new line.
        </>
      </TabTextbox>
      <textarea
        placeholder="Stock/Part Code,Qty (e.g. ABC456,1)"
        className={`copy-paste-form__textarea mt-20 bs-bb width-100 copy-paste-form__input ${
          hasErrorLines(errorLines)
            ? 'copy-paste-form__textarea--has-error'
            : ''
        }`}
        value={copyPasteTextArea}
        onChange={onChange}
      />
      {Object.entries(errorLines).map(
        ([key, val]) =>
          val.length > 0 && (
            <QuickOrdersError
              key={key}
              error={`${errorMessages[key]} on lines ${val}`}
              cn="fl ai-fs quick-order-cp-errors"
            />
          ),
      )}
      <Button
        className="copy-paste__submit-btn cef-btn cef-btn--green fs-16 fw-500 mt-36"
        label="Add to Manual Entry"
        disabled={copyPasteTextArea.length === 0}
        handleClick={handleSubmit}>
        Add to Manual Entry
      </Button>
    </div>
  );
};

export default CopyPasteForm;
